import { SelectionModel } from '@angular/cdk/collections';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { ProcedimentoAgendaDTO } from '../../../dtos/procedimento-agenda-dto';
import { ProcedimentoAgendaFiltroDTO } from '../../../dtos/procedimento-agenda-filtro-dto';
import { Medico } from '../../../medico/medico';
import { MedicoService } from '../../../medico/medico.service';
import { ChaveValorNumberInterface } from '../../../util/chave-valor-number-interface';
import { Util } from '../../../util/util';
import { Procedimento } from '../../procedimento';
import { ProcedimentoService } from '../../procedimento.service';
import { ProcedimentoAgendaPk } from '../pks/procedimento-agenda-pk';
import { ProcedimentoAgendaService } from '../procedimento-agenda.service';

@Component({
  selector: 'app-procedimento-agenda-list',
  templateUrl: './procedimento-agenda-list.component.html',
  styleUrls: ['./procedimento-agenda-list.component.css']
})
export class ProcedimentoAgendaListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['select', 'nomeFilial', 'diaSemana', 'horaAtendimento', 'quantidadeAtdGeral',
    'atdIdadeMinima', 'atdIdadeMaxima', 'tomadasFormatadas', 'nomeMedico', 'details'];

  formularioDeAgendaProcedimento: FormGroup;

  filtroProcedimentoAgenda: ProcedimentoAgendaFiltroDTO;

  listaDiasDaSemana: ChaveValorNumberInterface[] = Util.listaDiasDaSemana;

  listaMedicos: Medico[] = [];

  listaProcedimentos: Procedimento[] = [];

  selection: SelectionModel<any>;

  constructor(private procedimentoService: ProcedimentoService,
    private procedimentoAgendaService: ProcedimentoAgendaService,
    private medicoService: MedicoService, router: Router,
    dialog: MatDialog, private formBuilder: FormBuilder) {

    super(router, dialog);

    this.filtroProcedimentoAgenda = history.state.filtroProcedimentoAgenda;

    this.selection = new SelectionModel<any>(true, []);

    this.formularioDeAgendaProcedimento = this.formBuilder.group({
      procedimento: ['', [Validators.required]],
      medico: [''],
      diaSemana: [-1],
    });
  }

  ngOnInit() {

    super.ngOnInit();

    this.listarProcedimentos();

    this.listarMedicos();
  }

  listarProcedimentos() {
    this.procedimentoService.listarComProjecao()
      .subscribe(data => {
        // console.log( data)
        this.listaProcedimentos = data;

        this.listarMedicos();
      }, error => {
        console.log(error);
      });
  }

  listarMedicos() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaMedicos = data;

        this.configurarForm();
      }, error => {
        console.log(error);
      });
  }

  configurarForm(): void {

    if (this.filtroProcedimentoAgenda && this.filtroProcedimentoAgenda.procedimento) {

      this.formularioDeAgendaProcedimento.patchValue(this.filtroProcedimentoAgenda);

      if (this.listaProcedimentos) {
        let currentProcedimento = this.listaProcedimentos.filter(proc => proc.id == this.filtroProcedimentoAgenda.procedimento?.id)[0];
        this.formularioDeAgendaProcedimento.controls.procedimento.patchValue(currentProcedimento);
      }

      if (this.listaMedicos) {
        let currentMedico = this.listaMedicos.filter(medico => medico.id == this.filtroProcedimentoAgenda.medico?.id)[0];
        this.formularioDeAgendaProcedimento.controls.medico.patchValue(currentMedico);
      }

      this.reloadData(this.filtroProcedimentoAgenda);
    }
  }

  reloadData(filtro: ProcedimentoAgendaFiltroDTO) {

    if (filtro.procedimento) {

      this.limparSelecao();

      let diaSemanaSelecionado: number = -1;
      if (filtro.diaSemana) {
        diaSemanaSelecionado = filtro.diaSemana;
      }

      let idMedicoSelecionado: number = -1;
      if (filtro.medico) {
        idMedicoSelecionado = filtro.medico.id;
      }

      this.procedimentoAgendaService.listarProcedimentoAgendaComProjecao(filtro.procedimento.id, idMedicoSelecionado, diaSemanaSelecionado)
        .subscribe(data => {
          // console.log(data)

          const listaAgenda: Array<ProcedimentoAgendaDTO> = [];

          data.forEach((element: any) => {
            listaAgenda.push(Object.assign(new ProcedimentoAgendaDTO(), element));
          });

          this.data = listaAgenda;

          this.configurarDataSource();
        }, error => {
          console.log(error);
        });
    }
  }

  confirmDelete(id: ProcedimentoAgendaPk) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: ProcedimentoAgendaPk) {
    this.procedimentoAgendaService.removerAgendaProcedimento(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData(this.filtroProcedimentoAgenda);
        },
        error => {
          console.log(error);
        });
  }

  confirmDeleteLista() {
    if (this.selection.selected && this.selection.selected.length > 0) {
      const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirmação de exclusão',
          message: 'Deseja realmente remover o(s) registro(s) selecionado(s) ?'
        }
      });
      confirmDialog.afterClosed().subscribe(result => {
        if (result === true) {
          this.deleteLista();
        }
      });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos um procedimento agenda!'
        }
      });
    }
  }

  deleteLista() {

    this.procedimentoAgendaService.removerListaAgendaProcedimento(this.getListaDePksDoProcedimentoAgenda())
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData(this.filtroProcedimentoAgenda);
        },
        error => {
          console.log(error);
        });
  }

  addNovaAgenda() {

    const filtroProcedimentoAgenda: ProcedimentoAgendaFiltroDTO = this.formularioDeAgendaProcedimento.value;

    this.router.navigate(['manterProcedimentoAgenda'], {
      state: {
        isUpdate: 'N',
        filtroProcedimentoAgenda: filtroProcedimentoAgenda,
      }
    });
  }

  details(id: ProcedimentoAgendaPk) {

    const filtroProcedimentoAgenda: ProcedimentoAgendaFiltroDTO = this.formularioDeAgendaProcedimento.value;

    this.router.navigate(['manterProcedimentoAgenda'], {
      state: {
        id: id,
        isUpdate: 'N',
        filtroProcedimentoAgenda: filtroProcedimentoAgenda,
      }
    });
  }

  update(id: ProcedimentoAgendaPk) {

    const filtroProcedimentoAgenda: ProcedimentoAgendaFiltroDTO = this.formularioDeAgendaProcedimento.value;

    this.router.navigate(['manterProcedimentoAgenda'], {
      state: {
        id: id,
        isUpdate: 'S',
        filtroProcedimentoAgenda: filtroProcedimentoAgenda,
      }
    });
  }

  getListaDePksDoProcedimentoAgenda(): Array<ProcedimentoAgendaPk> {

    const listaPks: Array<ProcedimentoAgendaPk> = [];

    const listaProcedimentoAgenda: any = this.selection.selected;

    if (listaProcedimentoAgenda) {
      listaProcedimentoAgenda.forEach((agenda: any) => {

        listaPks.push(agenda.pkProcedimentoAgenda);

      });
    }

    return listaPks;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  limparSelecao(): void {

    this.selection.clear()

  }

  limparTabela(): void {

    this.limparSelecao();

    this.data = [];

    this.configurarDataSource();
  }

  onChangeMedico(event: MatSelectChange): void {
    //this.limparTabela();

    this.consultar();
  }

  onChangeProcedimento(event: MatSelectChange): void {
    //this.limparTabela();

    this.consultar();
  }

  onChangeDiaSemana(event: MatSelectChange): void {
    //this.limparTabela();

    this.consultar();
  }

  consultar() {
    this.filtroProcedimentoAgenda = this.formularioDeAgendaProcedimento.value;

    this.reloadData(this.filtroProcedimentoAgenda);
  }

  temItemSelecionado(): boolean {

    return this.selection.selected && this.selection.selected.length > 0;

  }

}
